import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Activity, ActivityIndicatorConfig, Indicator, IndicatorValue } from "../model/activity-config.model";

@Injectable({
    providedIn: "root",
})
export class ActivityConfigService {
    constructor(private readonly http: HttpClient) {}

    getActivities(): Observable<Activity[]> {
        return this.http.get<Activity[]>(`/vulnerability-profiles`);
    }

    /** Super Admin or the account's Client Admin */
    createActivity(accountId: number, name: string): Observable<Activity> {
        return this.http.post<Activity>(`/vulnerability-profiles?accountId=${accountId}`, { name });
    }

    getIndicators(): Observable<Indicator[]> {
        return this.http.get<Indicator[]>(`/indicators`);
    }

    getConfig(accountId: number, activityId: number): Observable<ActivityIndicatorConfig> {
        return this.http.get<ActivityIndicatorConfig>(`/activity-config/${accountId}/${activityId}`);
    }

    /** Every saved config for the account, in one call - what the table view needs. */
    getAllConfigs(accountId: number): Observable<ActivityIndicatorConfig[]> {
        return this.http.get<ActivityIndicatorConfig[]>(`/activity-config/${accountId}`);
    }

    saveConfig(accountId: number, activityId: number, indicatorValues: IndicatorValue[]): Observable<ActivityIndicatorConfig> {
        return this.http.post<ActivityIndicatorConfig>(`/activity-config/${accountId}/${activityId}/save`, indicatorValues);
    }

    updateConfig(accountId: number, activityId: number, indicatorValues: IndicatorValue[]): Observable<ActivityIndicatorConfig> {
        return this.http.put<ActivityIndicatorConfig>(`/activity-config/${accountId}/${activityId}/update`, indicatorValues);
    }

    /**
     * Deletes the profile type's configuration for this account and every stored score it
     * produced. The profile type itself stays in the shared master data, so the row remains
     * in the table with no percentages.
     */
    deleteConfig(accountId: number, activityId: number): Observable<void> {
        return this.http.delete<void>(`/activity-config/${accountId}/${activityId}`);
    }

    /** How many locations are still assigned to the profile type - any at all blocks its deletion. */
    countAssignedLocations(accountId: number, activityId: number): Observable<number> {
        return this.http.get<number>(`/activity-config/${accountId}/${activityId}/assigned-locations`);
    }
}
